var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCurvesPanelIcon = function SvgCurvesPanelIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 53,
    fill: "none",
    viewBox: "0 0 63 53"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D4355",
    strokeLinecap: "round",
    d: "M58.5 48.426h-52a2 2 0 0 1-2-2v-42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#CFD0FF",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M12.66 39.329c3.72-8.686 17.033-25.664 40.537-24.085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C95A8",
    d: "m54.576 38.92 1.265-1.778h1.294l-1.856 2.603 1.914 2.68h-1.289l-1.318-1.845-1.313 1.846h-1.295l1.915-2.681-1.851-2.603h1.284zM10.92 13.56q-.17 0-.326-.03a4 4 0 0 1-.293-.059l.16-.913.22.01q.128.01.206.01a.5.5 0 0 0 .307-.103q.136-.098.24-.224.098-.128.156-.225.063-.097.117-.205l.332-.63-2.25-5.049h1.283l1.314 3.228.18.58.22-.565 1.274-3.243h1.294l-2.68 6.084q-.093.205-.234.435a1.9 1.9 0 0 1-.845.762 1.56 1.56 0 0 1-.674.136"
  })));
};
export default SvgCurvesPanelIcon;